"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { type FormEvent, useState } from "react";
import { Button } from "../../components/ui/button";
import { TextField } from "../../components/ui/fields";
import { Notice } from "../../components/ui/notice";
import { api, errorMessage } from "../../lib/api/client";
import { safeNextPath } from "./next-path";

export function LoginForm() {
  const router = useRouter();
  const nextPath = safeNextPath(useSearchParams().get("next"));
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setPending(true);
    setError(null);
    try {
      await api.post(
        "/api/auth/login",
        { email: form.get("email"), password: form.get("password") },
        { skipUnauthorizedHandler: true },
      );
      router.replace(nextPath);
    } catch (err) {
      setError(errorMessage(err));
      setPending(false);
    }
  }

  return (
    <form onSubmit={submit} className="st-panel st-pad st-stack w-full max-w-[360px] gap-4">
      <h1 className="st-h-page">Muse 스튜디오</h1>
      <TextField label="이메일" name="email" type="email" autoComplete="username" required />
      <TextField
        label="비밀번호"
        name="password"
        type="password"
        autoComplete="current-password"
        required
      />
      {error !== null && <Notice tone="error">{error}</Notice>}
      <Button type="submit" disabled={pending} className="w-full">
        {pending ? "로그인 중…" : "로그인"}
      </Button>
    </form>
  );
}
